import React from 'react';
import ContactLinks from './ContactLinks';

function AboutSection() {
  return (
    <section
      id="about"
      className="flex min-w-0 items-center gap-1.5"
      aria-labelledby="about-heading"
    >
      <h2
        id="about-heading"
        className="shrink-0 whitespace-nowrap text-[9px] font-black text-white/60 md:text-[10px]"
      >
        誰製作了 RPS Chaos？
      </h2>

      <p className="truncate text-[9px] text-white/40 md:text-[10px]">
        <a
          href="https://homy.hk/"
          target="_blank"
          rel="author noopener noreferrer"
          className="font-black text-cyan-400/80 transition-colors hover:text-cyan-300"
        >
          Homy Tech
        </a>
        {' '}
        設計及開發這款互動式物理模擬遊戲
        <span className="hidden lg:inline">
          ，團隊專注互動網站、數碼產品與視覺體驗。
        </span>
      </p>
    </section>
  );
}

function ContactSection() {
  return (
    <section
      id="contact"
      className="flex shrink-0 items-center gap-2"
      aria-labelledby="contact-heading"
    >
      <h3
        id="contact-heading"
        className="whitespace-nowrap text-[9px] font-black text-white/60 md:text-[10px]"
      >
        如何聯絡 Homy Tech？
      </h3>

      <ContactLinks />
    </section>
  );
}

export default function SiteFooter() {
  return (
    <footer
      className="mt-4 flex shrink-0 items-center justify-between gap-3 pb-1"
      aria-label="關於 RPS Chaos 及聯絡 Homy Tech"
    >
      <div className="flex min-w-0 items-center gap-3">
        <AboutSection />

        <span
          className="hidden h-3 w-px shrink-0 bg-white/10 sm:block"
          aria-hidden="true"
        />

        <ContactSection />
      </div>

      <a
        href="https://homy.hk/"
        target="_blank"
        rel="author noopener noreferrer"
        className="hidden shrink-0 text-[9px] font-black tracking-[0.05em] text-white/40 no-underline transition-colors hover:text-cyan-400 md:block md:text-[10px]"
        aria-label="前往 RPS Chaos 開發團隊 Homy Tech 的官方網站"
      >
        © 2026 Homy Tech
      </a>
    </footer>
  );
}